import React, { useState,useEffect, useRef } from "react";
import { Link,useNavigate } from "react-router-dom";
import axios from 'axios';
import { ExecuteLoginBranch,isNull } from "../../components/common/Common"; 
import "../../css/style.css";


const LoginBranch = () => {
  const navigate = useNavigate();

  const refID = useRef()
  const refPwd = useRef();
  const refLogin = useRef();

  const [varLoginInfo,setLoginInfo] = useState({bh_id:"", bh_pwd:"", auto_login:0});
  const [isLoading, setIsLoading] = useState(true);

  //저장된 변수값이 존재하지 않으면 초기화
  useEffect(() => {
    if(isNull(localStorage.getItem("branchLoginState"))) {
      localStorage.setItem("branchLoginState",0);
    }
    if(isNull(localStorage.getItem("branch_autoLogin"))) {
      localStorage.setItem("branch_autoLogin",0);
    }
  }, []);

  //입력값 저장
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    if(name === "bh_id") {
      const svalue = value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g,'');
      setLoginInfo({...varLoginInfo,[name]:svalue});
    } else {
      setLoginInfo({...varLoginInfo,[name]:value});
    }
  }

  //자동로그인
  const onSetAutoLoginHandler = (e) => {
    const bmode = Number(e.currentTarget.checked);
    setLoginInfo({...varLoginInfo,auto_login:bmode});
    localStorage.setItem("branch_autoLogin",bmode);
  }

  //수동로그인
  const onLoginProgressHandler =  (e) => {
    if(varLoginInfo.bh_id === "") {
      alert('로그인하기 위한 아이디를 먼저 입력하세요.');
      return false;
    }
    if(varLoginInfo.bh_pwd === "") {
      alert('로그인하기 위한 비밀번호를 먼저 입력하세요.');
      return false;
    }
    const bh_device = localStorage.getItem('fcm_token') || "";
    const sendData = {login_mode:1,loginInfo:varLoginInfo,bh_device:bh_device};
    loginProgressing(sendData);
  }

  //서버로부터 로그인 확인
  const loginProgressing = async (sendData) => {
    try {
      console.log(sendData);
      const res = await axios.post(`${process.env.REACT_APP_HOST}/branch_login_progress`,sendData);
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const branchs = datas.results[0];
        //로그인설정
        ExecuteLoginBranch(branchs);
        //메인화면에 표시할 날짜 초기화
        localStorage.removeItem('mainDate');
        //페이지이동
        navigate(`/MainBranch`);
      } else {
        refPwd.current.value = "";
        refID.current.value = "";
        refID.current.focus();
        alert(datas.message);
      }
    } catch (error) {
      console.error("로그인 중 오류 발생:", error);
    }
  }
 
  //FCM TOKEN 메모리에 저장------------------------------------------------------------------------------------------------
  //실행함수
  const eventFromAndroid = async (e) => {
    try {
      localStorage.setItem('fcm_token', e?.detail?.token || "");
    } catch (error) {
      console.error("FCM 토큰 저장 중 오류:", error);
    }
  }

  //최초실행부
  useEffect(() => {
    //네이티브에 기기코드 요청
    const mobileType = navigator.userAgent.toLowerCase();
    console.log("모바일 타입:", mobileType);

    // iOS 기기 감지 함수
    const isIOSDevice = () => {
      return (
        mobileType.indexOf('iphone') > -1 || 
        mobileType.indexOf('ipad') > -1 || 
        mobileType.indexOf('ipod') > -1 ||
        (navigator.maxTouchPoints > 0 && 
         mobileType.indexOf('mac') > -1 && 
         'ontouchend' in document)
      );
    };

    try {
      if (mobileType.indexOf('android') > -1) {
        if(window.mamamonteP){
          //안드로이드로부터 받기
          window.addEventListener("onFcmInfoSuccess", eventFromAndroid);
          //안드로이드로 보내기
          window.mamamonteP.getFcmInfo();
        } 
      }
      // } else if (mobileType.indexOf('iphone') > -1 || mobileType.indexOf('ipad') > -1 || mobileType.indexOf('ipod') > -1) {
      // if(!isNull(window.webkit) && mobileType.indexOf('mamamontep_ios_app') > -1) {
      //   alert('모바일타입:' + mobileType + ' iOS 웹뷰 브릿지 상태: ' + window.webkit);
      //   window.webkit.messageHandlers.getFcmInfo.postMessage('');
      // } 
      // else if (isIOSDevice()) {
      //   console.log("iOS 기기 감지됨");
      // iOS 앱 확인 - USER_AGENT 변경
      else if (mobileType.indexOf('MamamonteP_IOS_APP'.toLowerCase()) > -1) {
        console.log("iOS 앱 감지됨");
        if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getFcmInfo) {
          // iOS FCM 이벤트 리스너 먼저 등록
          window.onFcmInfoSuccess = (e) => {
            const event = { detail: { token: e } };
            eventFromAndroid(event);
          };
          
          // 리스너 등록 후 FCM 정보 요청
          setTimeout(() => {
            window.webkit.messageHandlers.getFcmInfo.postMessage('');
          }, 100);
        } else {
          console.log("webkit 객체 없음 또는 getFcmInfo 없음", window.webkit);
        }
      }
      // 일반 iOS 기기 감지
      else if (isIOSDevice()) {
        console.log("일반 iOS 기기 감지됨");
      }
    } catch (error) {
      console.error("기기 감지 중 오류:", error);
    }

    //저장되어 있는 변수값 호출
    try {
      const autoLogin = Number(localStorage.getItem("branch_autoLogin") || "0");
      setLoginInfo(prev => ({...prev, auto_login: autoLogin}));
      setIsLoading(false);

      //auto_login---------
      if(autoLogin === 1) {
        if(!isNull(localStorage.getItem("branch_idx"))) {
          const idx = Number(localStorage.getItem("branch_idx"));
          const bh_device = localStorage.getItem('fcm_token') || "";
          if(idx > 0) {
            const sendData = {login_mode:0,bh_idx:idx,bh_device:bh_device};
            loginProgressing(sendData);
          }
        }
      }
    } catch (error) {
      console.error("자동 로그인 처리 중 오류:", error);
      setIsLoading(false);
    }

    //페이지 종료시 실행
    return () => {
      try {
        if(window.mamamonteP && mobileType.indexOf('android') > -1){
          window.removeEventListener("onFcmInfoSuccess", eventFromAndroid);
        }
        else if(window.webkit){
          window.onFcmInfoSuccess = null;
        }
      } catch (error) {
        console.error("이벤트 리스너 제거 중 오류:", error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //키보드 입력값 조정
  const onKeyPressHandler = (e,ino) => {
    if (e.key === 'Enter') {
      if(ino === 0) {
        refPwd.current.focus();
      } else {
        refLogin.current.click();
      }
    }
  }

  if (isLoading) {
    return <div className="center-login-wrap">로딩 중...</div>;
  }

  return (
    <div className="center-login-wrap">
      <div className="login-txt mb10">
        센터 인증<br/>로그인을 하세요
      </div>
      <div className="login-form mb25">
        <div className="field-group mb10">
          <span>아이디</span>
          <input type="text" name="bh_id" ref={refID} placeholder="아이디를 입력하세요." className="form-control form-id" onKeyPress={e=>onKeyPressHandler(e,0)} onChange={e=>onChangeInputHandler(e)}/>
        </div>
        <div className="field-group mb15">
          <span>비밀번호</span>
          <input type="password" name="bh_pwd" ref={refPwd} placeholder="비밀번호를 입력하세요." className="form-control form-pw" onKeyPress={e=>onKeyPressHandler(e,1)} onChange={e=>onChangeInputHandler(e)}/>
        </div>
        <div className="auto-login mb40">
          <div className="checkbox">
            <input type="checkbox" name="auto_login" id="loginAuto" checked={varLoginInfo.auto_login === 1} onChange={e=>onSetAutoLoginHandler(e)}/>
            <label htmlFor="loginAuto">자동 로그인</label>
          </div>
        </div>
        <div className="find-login mb20">
          <Link to="/Branch/JoinUs">회원가입</Link>
          <Link to="/Branch/FindID">아이디 찾기</Link>
          <Link to="/Branch/FindPWD">비밀번호 찾기</Link>
        </div>
        <div className="form-contoller flex-vertical">
          <button ref={refLogin} className="form-contoller-btn btn-100" onClick={e=>onLoginProgressHandler(e)}>로그인</button>
        </div>
      </div>
    </div>
  )
}
export default LoginBranch;